import { createSelector } from "reselect"
import { createQueryStringSelector } from "selectors/queryString"
import { get, keyBy, size, isEmpty, includes } from "lodash"
import { AGGREGATION_FUNCTIONS } from "helpers/factorClassification"
import { aggregateFactors } from "helpers/factorClassification/index"
import { computeFactorsMetadata, computeSelectedViews, computeSelectedViewsFactors, mergeCategories } from "helpers/factors"
import { getSelectedScreen, getSelectedSubScreen } from "."
import { getModelFactors, getModelCategories, getModelFactorsClassification } from "selectors/modelMetadata"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}

export const getRawSelectedViews = createQueryStringSelector("views", EMPTY_ARRAY)
export const getAggregationFunction = createQueryStringSelector("styleAggregation", AGGREGATION_FUNCTIONS.NONE)
export const getFavoriteFactors = state => get(state, "global.data.userFavoriteFactors.data.0.value", EMPTY_OBJECT)

export const getMustAggregateFactors = createSelector(
  [getModelFactorsClassification],
  (factorsClassification) => !isEmpty(factorsClassification),
)

const getFactorsAggregationOptions = createSelector(
  [getAggregationFunction, getSelectedScreen, getSelectedSubScreen],
  (styleAggregation, selectedScreen, selectedSubScreen) => {
    const styleFactorNotAdditive = selectedScreen === "trends" && includes(["exposure", "factor-sensitivity"], selectedSubScreen)
    return { isStyleFactorsAdditive: !styleFactorNotAdditive, styleAggregation }
  },
)

export const getSelectViewAggregatedFactorsMetadata = createSelector(
  [getModelFactors, getMustAggregateFactors, getModelFactorsClassification],
  (rawFactors, mustAggregateFactors, factorsClassification) => {
    if (!mustAggregateFactors) {
      return rawFactors
    }

    const factors = aggregateFactors(factorsClassification, rawFactors)
    return keyBy(factors, "id")
  },
)

export const getSelectedViews = createSelector(
  [getRawSelectedViews, getSelectViewAggregatedFactorsMetadata, getMustAggregateFactors],
  computeSelectedViews,
)

export const getSelectedViewsFactors = createSelector(
  [getSelectedViews, getModelFactors, getModelFactorsClassification],
  computeSelectedViewsFactors,
)

export const getFactorsMetadata = createSelector(
  [getModelFactors, getModelFactorsClassification, getSelectedViewsFactors, getFactorsAggregationOptions],
  computeFactorsMetadata,
)

export const getCategories = createSelector(
  [getModelCategories, getSelectedViews],
  mergeCategories,
)

export const getDisplayAddView = createSelector(
  [getMustAggregateFactors, getSelectedViews],
  (mustAggregateFactors, selectedViews) => mustAggregateFactors && size(selectedViews) < 10,
)
